export default "__VITE_ASSET__WTyA9YVx__"